import { AnnualReportTabs } from '@/module/AnnualReport/AnnualReportTabs';
import { AnnualReportOverview } from '@/module/AnnualReport/model/AnnualReportTypes';

interface AnnualReportOverviewProps {
  overview: AnnualReportOverview;
  year: number;
}

export function AnnualReportOverviewBox({ overview, year }: AnnualReportOverviewProps) {
  const { awards, projects, papers, patents, technologicalTransfers, texts, count } = overview;

  return (
    <AnnualReportTabs
      awards={awards}
      projects={projects}
      papers={papers}
      patents={patents}
      technologicalTransfers={technologicalTransfers}
      texts={texts}
      count={count}
      year={year}
    />
  );
}
